<template>
  <div>
    <div class="about-banner">
      <img src="@/assets/images/images/about-img.png" />
      <div class="bannerTxt">
        <div class="key">工业行业模型</div>
        <div class="val">
          提供众多具备行业特色的工业模型，其将工业知识经验进行提炼和封装，推动行业知识经验在平台的沉淀集聚，赋能企业的数字化转型。
        </div>
      </div>
    </div>
    <div>
      <div class="title">行业模型</div>
      <ul class="applist">
        <li v-for="app in appHomePageList" :key="app.id" class="appitem" @click="gotoAppitem(app)">
          <div>
            <img :src="app.appLogoFullUrl" />
          </div>
          <div class="appTitle">
            {{ app.appTitle }}
          </div>
          <div class="appProfile">{{ app.appProfile }}</div>
        </li>
      </ul>
      <div class="pag">
        <el-pagination
          class="pagination"
          layout="total, prev, pager, next"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-size="pageSize"
          :current-page="pageNo"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getAppHomePageList } from "@/api/index.js";
export default {
  data() {
    return {
      appHomePageList: [],
      pageNo: 1,
      pageSize: 9,
      total: 0,
    };
  },
  created() {
    this.getAppHomePageList();
  },
  methods: {
    gotoAppitem(item){
        location.href=item.detailUrl
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageNo = 1;
      this.getAppHomePageList();
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getAppHomePageList();
    },
    getAppHomePageList() {
      const params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        appClassify: "mechanism_model",
      };
      getAppHomePageList(params).then((res) => {
        if (res.code == 0) {
          this.appHomePageList = res.data.items;
          this.total = res.data.totalCount;
        }
        console.log("res222", res);
      });
    },
  },
};
</script>

<style lang="less" scoped>
.about-banner {
  width: 100%;
  height: 412px;
  position: relative;
  .bannerTxt {
    width: 1281px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    margin-top: 107px;
  }
  .key {
    width: 547px;
    height: 62px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 44px;
    color: #293341;
    line-height: 62px;
    text-align: left;
    font-style: normal;
  }
  .val {
    width: 618px;
    height: 99px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 18px;
    color: #293341;
    line-height: 33px;
    text-align: left;
    font-style: normal;
    margin-top: 13px;
  }
  img {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
}
.title {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 36px;
  color: #2a313b;
  line-height: 36px;
  font-style: normal;
  margin: 80px auto 0 auto;
  text-align: center;
}
.applist {
  display: flex;
  width: 1281px;
  flex-wrap: wrap;
  margin: 63px auto 40px auto;
  .appitem {
    cursor: pointer;
    width: 413px;
    height: 210px;
    background: linear-gradient(180deg, #f4f5f8 2%, #ffffff 100%);
    box-shadow: 8px 8px 20px 0px rgba(0, 0, 0, 0.04),
      -8px -8px 20px 0px rgba(0, 0, 0, 0.02);
    border: 2px solid #ffffff;
    padding: 20px 30px;
    box-sizing: border-box;
    margin-bottom: 20px;
    list-style: none;
    margin-right: 20px;
    img {
      width: 44px;
      height: 44px;
    }
    .appTitle {
      margin-top: 13px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 16px;
      color: #354052;
      line-height: 22px;
      text-align: left;
      font-style: normal;
    }
    .appProfile {
      margin-top: 6px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #354052;
      line-height: 25px;
      text-align: left;
      font-style: normal;
    }
  }
  .appitem:nth-child(3n){
    margin-right: 0;
  }
}
.pag {
  text-align: center;
  margin-bottom: 40px;
}
</style>
